<template>
	<div class="col" gutter="20">
		<Title title="評審故事" />
		<div class="row" align-x="between" align-y="bottom">
			<div class="col" gutter="20" align-x="left">
				<el-button type="info" @click="handleDownload()">下載評分資料</el-button>
				<div class="row" align-y="center" gutter="10">
					<el-radio-group v-model="status" @change="statusChange">
						<el-radio-button label="全部" />
						<el-radio-button label="尚未評審" />
						<el-radio-button label="評審中" />
						<el-radio-button label="已評審" />
					</el-radio-group>
					<el-select v-model="session" placeholder="屆數" @change="handleSessionChange" clearable>
						<el-option v-for="option in sessionFilters" :key="option" :label="option" :value="option" />
					</el-select>
				</div>
			</div>
			<SearchBar :searchText="searchText" @search="handleSearch" placeholder="故事帳號、故事名稱" />
		</div>
		<el-pagination align-self="right" class="layout-row layout-justify-center" @size-change="sizeChange" @current-change="currentChange" :current-page="page" :page-sizes="[10, 30, 50]" :page-size="size" layout="total, sizes, prev, pager, next, jumper" :total="storyList.total" />
		<el-table :data="judgeStoryList" style="width: 100%" :default-sort="{prop: 'account', order: 'descending'}">
			<el-table-column prop="account" label="故事帳號" sortable width="120" />
			<el-table-column prop="story_name" label="故事名稱" />
			<el-table-column label="F" width="50">
				<template slot-scope="{row}">
					{{row.judgement && mapScore(row.judgement.judge_table, 'F')}}
				</template>
			</el-table-column>
			<el-table-column label="I" width="50">
				<template slot-scope="{row}">
					{{row.judgement && mapScore(row.judgement.judge_table, 'I')}}
				</template>
			</el-table-column>
			<el-table-column label="D" width="50">
				<template slot-scope="{row}">
					{{row.judgement && mapScore(row.judgement.judge_table, 'D')}}
				</template>
			</el-table-column>
			<el-table-column label="S" width="50">
				<template slot-scope="{row}">
					{{row.judgement && mapScore(row.judgement.judge_table, 'S')}}
				</template>
			</el-table-column>
			<el-table-column prop="is_participate" label="是否分享" align="center">
				<el-tag slot-scope="{row}" :type="!row.is_participate && 'info' || ''">{{row.is_participate ? "是" : "否"}}</el-tag>
			</el-table-column>
			<el-table-column prop="judgement.assessment" label="設計思考" align="center" />
			<el-table-column label="狀態" align="center">
				<template slot-scope="{row}">
					{{mapApplyStatus(row.apply_status)}}
				</template>
			</el-table-column>
			<el-table-column label="檢視" width="100">
				<template slot-scope="{row}">
					<router-link :to="{name: 'judgeStory', params:{id: row.id}}">內容</router-link>
				</template>
			</el-table-column>
		</el-table>
		<el-pagination align-self="right" class="layout-row layout-justify-center" @size-change="sizeChange" @current-change="currentChange" :current-page="page" :page-sizes="[10, 30, 50]" :page-size="size" layout="total, sizes, prev, pager, next, jumper" :total="storyList.total" />

		<div style="width:0;height:0;overflow:hidden;">
			<table ref="downloadTable" v-html="tbody" border="1"></table>
		</div>
	</div>
</template>

<script>
import Title from "@/components/backendManage/Title";
import SearchBar from "@/components/backendManage/SearchBar";
import { mapActions, mapState } from "vuex";
import xlsx from "@/libs/xlsx";
import { getCurrentSessionYear } from "@/libs/session";
import moment from "moment-timezone";

export default {
	mixins: [xlsx],
	components: { Title, SearchBar },
	data() {
		return {
			session: "",
			page: 1,
			size: 10,
			searchText: "",
			status: "全部",
			downloadList: [],
			tbody: ""
		};
	},
	computed: {
		...mapState('story', ['storyList']),
		query() {
			return {
				page: this.page,
				size: this.size,
				text: this.searchText,
				status: this.status,
				session: this.session,
			};
		},
		judgeStoryList() {
			return this.storyList.list || [];
		},
		sessionFilters() {
			const start = 2018;
			const now = getCurrentSessionYear();
			let arr = [];
			for (let i = start; i <= now; i++) arr.push(i);
			return arr;
		},
	},
	watch: {
		async $route() {
			await this.getJudgeStories(this.query);
		}
	},
	methods: {
		...mapActions('story', ['getJudgeStories', 'getJudgedStories']),
		init() {
			this.page = Number(this.$route.query.page) || 1;
			this.size = Number(this.$route.query.size) || 10;
			this.searchText = this.$route.query.text || '';
			this.status = this.$route.query.status || '全部';
		},
		mapApplyStatus(status) {
			switch (status) {
				case 4:
					return '尚未評審';
				case 5:
					return '評審中';
				case 6:
					return '已評審';
				default:
					return;
			}
		},
		mapScore(arr, step) {
			return arr.filter(o => o.label == step).reduce((a, b) => a += b.achieved ? 2 : 0, 1);
		},
		handleSearch(text) {
			this.searchText = text;
			this.page = 1
			this.$router.replace({ query: this.query });
		},
		sizeChange(size) {
			this.size = size;
			this.page = 1
			this.$router.replace({ query: this.query });
		},
		currentChange(page) {
			this.page = page;
			this.$router.replace({ query: this.query });
		},
		statusChange(status) {
			this.status = status;
			this.page = 1;
			this.$router.replace({ query: this.query });
		},
		handleSessionChange(val) {
			this.session = val;
			this.page = 1;
			this.$router.replace({ query: this.query });
		},
		async handleDownload() {
			this.downloadList = await this.getJudgedStories();
			let tbody = `<tr>
				<th>故事代號</th>
				<th>故事名稱</th>
				<th>感受</th>
				<th>想像</th>
				<th>實踐</th>
				<th>分享</th>
				<th>評語</th>
				<th>繳交時間</th>
				<th>評分時間</th>
			</tr>`;
			this.downloadList.forEach(row => {
				tbody += `<tr>
					<td>${row.account || ""}</td>
					<td>${row.story_name || ""}</td>
					<td>${this.mapScore(row.judgement.judge_table, 'F') || ""}</td>
					<td>${this.mapScore(row.judgement.judge_table, 'I') || ""}</td>
					<td>${this.mapScore(row.judgement.judge_table, 'D') || ""}</td>
					<td>${this.mapScore(row.judgement.judge_table, 'S') || ""}</td>
					<td>${row.judgement.comments.join("\n\n") || ""}</td>
					<td>${row.apply_time && moment(row.apply_time).tz("Asia/Taipei").format("YYYY-MM-DD, HH:mm") || ""}</td>
					<td>${row.judgement.judge_time && moment(row.judgement.judge_time).tz("Asia/Taipei").format("YYYY-MM-DD, HH:mm") || ""}</td>
				</tr>`;
			});
			this.tbody = tbody;
			this.$nextTick(() => {
				this.saveAsXLSX(this.$refs["downloadTable"], "評審結果.xlsx");
			});
		}
	},
	async created() {
		this.init();
		await this.getJudgeStories(this.query);
	}
};
</script>